import React, { useEffect, useState } from "react";
import { HeroSm, NavBar, Spinner } from "../components";
import { Footer } from "../layouts";
import $ from "jquery";
import { Link } from "react-router-dom";
import { Slang } from "../helpers";

const NotFoundPage = () => {
  const [loadPage, setLoadPage] = useState(true);
  const [spinColor, setSpinColor] = useState("success");
  // const clrs = ["primary", "body", "success", "info", "danger", "warning", "info", "success", "light", "dark"];

  useEffect(() => {
    // let tim1 = setInterval(() => {
    //     setSpinColor(clrs[parseInt(Math.random() * 10)]);
    // }, 2000);

    let tim2 = setTimeout(() => {
      setLoadPage(false);
    }, 100);

    return () => {
      clearInterval(tim2);
    };
  }, []);

  return (
    <>
      {loadPage ? (
        <>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
              width: "100%",
              position: "fixed",
              left: 0,
              top: 0,
            }}
          >
            <Spinner color={spinColor} size={3} />
          </div>
        </>
      ) : (
        <Main />
      )}

      {/*<Helmet>*/}
      {/*    /!* <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;600&display=swap" rel="stylesheet" /> *!/*/}
      {/*    <title>404 Not Found</title>*/}
      {/*    <link rel="stylesheet" href="./assets/css/bootstrap/icons/bootstrap-icons.css" />*/}
      {/*    <link rel="stylesheet" href="./assets/css/hs/mega-menu/mega-menu.min.css" />*/}
      {/*    <link rel="stylesheet" href="./assets/css/_theme.css" />*/}

      {/*    <script defer asyn src="./assets/js/bootstrap/bootstrap.bundle.min.js"></script>*/}
      {/*    <script defer asyn src="./assets/js/hs/go-to/goto.min.js"></script>*/}
      {/*    <script defer asyn src="./assets/js/prism/prism.js"></script>*/}
      {/*    <script defer asyn src="./assets/js/hs/show-animation/show-animation.min.js"></script>*/}
      {/*    <script defer asyn src="./assets/js/hs/mega-menu/mega-menu.min.js"></script>*/}
      {/*    <script defer asyn src="./assets/js/hs/header/header.min.js"></script>*/}
      {/*    <script defer asyn src="./assets/js/fslightbox/index.js"></script>*/}
      {/*    <script defer asyn src="./assets/js/theme.min.js"></script>*/}

      {/*</Helmet>*/}
    </>
  );
};

export default NotFoundPage;

const Main = () => {
  const lang = Slang("NotFound");

  useEffect(() => {
    const script = `
            new HSGoTo('.js-go-to');
            new HSHeader('#header').init();
            new HSMegaMenu('.js-mega-menu', {"desktop": {"position": "left"}});
        `;

    $("body").append(`<script className="homescript">${script}</script>`);

    return () => {
      $(".homescript").remove();
    };
  }, []);

  return (
    <>
      <NavBar />
      <HeroSm title={lang("t1")} />
      <main id="content" role="main">
        <div className="container text-center content-space-t-1 content-space-t-lg-2 content-space-b-1 content-space-b-lg-2">
          <div className="mb-3">
            <img
              className="img-fluid"
              src="./assets/img/svg/illustrations/oc-error.svg"
              alt="Description_Image"
              style={{ width: "30rem" }}
            />
          </div>

          <div className="mb-4">
            <p className="fs-4 mb-0">{lang("t2")}</p>
            <p className="fs-4">
              {lang("t3")}
              <a className="link" href="#">
                {lang("t4")}
              </a>
              .
            </p>
          </div>

          <Link className="btn btn-primary" to="/">
            {lang("t5")}
          </Link>
        </div>
      </main>
      <Footer />
    </>
  );
};
